var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaflet-tooltip",class:{'leaflet-tooltip-left': _vm.left, 'leaflet-tooltip-right': _vm.right},style:(_vm.style)},[_vm._v(" "+_vm._s(this.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }